module.exports = __webpack_public_path__ + "static/media/answers-profile-pic-3.77576b15.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/answers-profile-pic-3.png
// module id = 1053
// module chunks = 0